import type { ServiceOptions } from 'src/types';

import rtwClient from '../apiService';

import type {
  AssociateProfile,
  AssociateProfilePlacement,
  AssociateProfilePlacementsResponse,
  AssociateProfileRestrictionsResponse,
  ModifiedDutySummaryResponse,
} from './types';

function verifyAlias(alias: string) {
  if (!alias) {
    throw new Error('Alias is required');
  }
}
function verifySiteId(siteId: number) {
  if (!siteId) {
    throw new Error('Site ID is required');
  }
}

class AssociateProfileService {
  public async getAssociateProfile(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await rtwClient.get<AssociateProfile>(`/associateProfile/${alias}/sites/${siteId}`, {
      signal: options?.signal,
    });
  }

  public async getAssociateProfilePlacements(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await rtwClient.get<AssociateProfilePlacementsResponse>(
      `/associateProfile/${alias}/sites/${siteId}/placements`,
      { signal: options?.signal },
    );
  }

  public async getAssociateProfileRestrictions(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await rtwClient.get<AssociateProfileRestrictionsResponse>(
      `/associateProfile/${alias}/sites/${siteId}/restrictions`,
      { signal: options?.signal },
    );
  }

  public async getLastPlacementDate(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await rtwClient.get<string>(`/associateProfile/${alias}/sites/${siteId}/lastPlacementDate`, {
      signal: options?.signal,
    });
  }

  public async getAssociateProfileHistory(alias: string, siteId: number, options?: ServiceOptions) {
    verifyAlias(alias);
    verifySiteId(siteId);

    return await rtwClient.get<Array<AssociateProfilePlacement>>(
      `/associateProfile/${alias}/sites/${siteId}/placements/closed`,
      { signal: options?.signal },
    );
  }

  public async getModifiedDutySummary(alias: string, options?: ServiceOptions) {
    verifyAlias(alias);

    return await rtwClient.get<ModifiedDutySummaryResponse>(`/associateProfile/modifiedDutySummary/${alias}`, {
      signal: options?.signal,
    });
  }
}

export default new AssociateProfileService();
